import React from "react";

const ExternalLink = () => {
  return (
<svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.2223 3H13.0002V5.77785" stroke="#6A6A6A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.11078 6.88899L12.9998 3" stroke="#6A6A6A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.8891 9.11078V11.8886C11.8891 12.5025 11.3919 12.9998 10.778 12.9998H4.11114C3.49724 12.9998 3 12.5025 3 11.8886V5.22179C3 4.60788 3.49724 4.11065 4.11114 4.11065H6.88899" stroke="#6A6A6A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ExternalLink;
